import { Box } from '@chakra-ui/react'
import React from 'react'

const Border = () => {
  return (
    <Box
    w='100%'
    h='10px'
    bgGradient='linear(to-l,#e7422e, #fe4980,#fea12b)'
    >
    </Box>
  )
}

export default Border